import { render, staticRenderFns } from "./TemplatesDatatable.vue?vue&type=template&id=3b66f997"
import script from "./TemplatesDatatable.vue?vue&type=script&lang=js"
export * from "./TemplatesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports